import { Action } from '@ngrx/store';
import { ForgotPasswordForm, ResetPasswordForm } from '../models/forgot-password';

export const FORGOT_PASSWORD = '[Forgot Password] Init';
export const FORGOT_PASSWORD_SUCCESS = '[Forgot Password] Success';
export const FORGOT_PASSWORD_FAILURE = '[Forgot Password] Failure';
export const FORGOT_PASSWORD_RESET = '[Forgot Password] Reset';
export const FORGOT_PASSWORD_REDIRECT = '[Forgot Password] Redirect';
export const FORGOT_PASSWORD_REDIRECT_SUCCESS = '[Forgot Password] Redirect Success';
export const FORGOT_PASSWORD_REDIRECT_FAILURE = '[Forgot Password] Redirect Failure';
export const FORGOT_PASSWORD_SEND_EMAIL_LINK = '[Forgot Password] Send Email Link';
export const FORGOT_PASSWORD_SEND_EMAIL_LINK_SUCCESS = '[Forgot Password] Send Email Link Success';
export const FORGOT_PASSWORD_SEND_EMAIL_LINK_FAILURE = '[Forgot Password] Send Email Link Failure';

export const RESET_PASSWORD = '[Forgot] Init';
export const RESET_PASSWORD_SUCCESS = '[Forgot] Success';
export const RESET_PASSWORD_FAILURE = '[Forgot] Failure';
export const RESET_PASSWORD_UPDATE_PASSWORD_REDIRECT = '[Forgot] Redirect';


export class ForgotPassword implements Action {
  readonly type = FORGOT_PASSWORD;

  constructor(public payload: ForgotPasswordForm) {
  }
}

export class ForgotPasswordReset implements Action {
  readonly type = FORGOT_PASSWORD_RESET;

  constructor(public payload: ResetPasswordForm) {
  }
}

export class ForgotPasswordResetSuccess implements Action {
  readonly type = RESET_PASSWORD_FAILURE;

  constructor(public payload: ResetPasswordForm) {
  }
}

export class ForgotPasswordResetFailure implements Action {
  readonly type = RESET_PASSWORD_UPDATE_PASSWORD_REDIRECT;

  constructor(public payload: ResetPasswordForm) {
  }
}

export class ForgotPasswordSuccess implements Action {
  readonly type = FORGOT_PASSWORD_SUCCESS;

  constructor(public payload?: any) {
  }
}

export class ForgotPasswordRedirect implements Action {
  readonly type = FORGOT_PASSWORD_REDIRECT;

  constructor(public payload?: any) {
  }
}

export class ForgotPasswordRedirectSuccess implements Action {
  readonly type = FORGOT_PASSWORD_REDIRECT_SUCCESS;

  constructor(public payload?: any) {
  }
}

export class ForgotPasswordRedirectFailure implements Action {
  readonly type = FORGOT_PASSWORD_REDIRECT_FAILURE;

  constructor(public payload?: any) {
  }
}

export class ForgotPasswordFailure implements Action {
  readonly type = FORGOT_PASSWORD_FAILURE;

  constructor(public payload: any) {
  }
}

export class ResetPasswordUpdatePasswordRedirect implements Action {
  readonly type = RESET_PASSWORD_UPDATE_PASSWORD_REDIRECT;
}

export class ForgotPasswordSendEmailLink implements Action {
  readonly type = FORGOT_PASSWORD_SEND_EMAIL_LINK;

  constructor(public payload: any) {
  }
}

export class ForgotPasswordSendEmailLinkSuccess implements Action {
  readonly type = FORGOT_PASSWORD_SEND_EMAIL_LINK_SUCCESS;
}

export class ForgotPasswordSendEmailLinkFailure implements Action {
  readonly type = FORGOT_PASSWORD_SEND_EMAIL_LINK_FAILURE;

  constructor(public payload: any) {
  }
}

export class ResetPassword implements Action {
  readonly type = RESET_PASSWORD;

  constructor(public payload: any, code) {
    this.payload.code = code;

  }
}

export class ResetPasswordSuccess implements Action {
  readonly type = RESET_PASSWORD_SUCCESS;
}

export class ResetPasswordFailure implements Action {
  readonly type = RESET_PASSWORD_FAILURE;

  constructor(public payload: any) {
  }
}


export type Actions =
  | ForgotPasswordRedirect
  | ForgotPasswordReset
  | ForgotPassword
  | ForgotPasswordSuccess
  | ForgotPasswordResetSuccess
  | ForgotPasswordResetFailure
  | ForgotPasswordRedirectSuccess
  | ForgotPasswordRedirectFailure
  | ForgotPasswordFailure
  | ForgotPasswordSendEmailLink
  | ForgotPasswordSendEmailLinkSuccess
  | ForgotPasswordSendEmailLinkFailure
  | ResetPassword
  | ResetPasswordSuccess
  | ResetPasswordFailure
  | ResetPasswordUpdatePasswordRedirect;



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/actions/forgot-password.ts